import { useSelector } from 'react-redux';

import { selectActiveOfferId } from '../../common/selectors/listingModal';

export const checkIsOfferPreviewEnabled = (activeOfferId: number | null) =>
  activeOfferId !== null && activeOfferId !== -1;

export function useIsOfferPreviewEnabled() {
  const activeOfferId = useSelector(selectActiveOfferId);

  return checkIsOfferPreviewEnabled(activeOfferId);
}
